import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, InspectionPlugin, InspectionPoint, Icons } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { ObservationsAndRecommandationsPluginService } from './observationsandrecommandations-plugin.service';
import * as _ from 'lodash';

@Component({
    templateUrl: './observationsandrecommandations.component.html',
    standalone: false
})
export class ObservationsAndRecommandationsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  observationsAndRecommandations: any;
  public inspection: Inspection;

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private service: ObservationsAndRecommandationsPluginService
  ) {
    super();
  }

  ngOnInit() {}

  public getMachineName(index: string) {
    return this.service.getMachineName(index);
  }

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.observationsAndRecommandations = this.plugin.config.ObservationsAndRecommandations;
    this.initData();
    this.cdRef.detectChanges();
  }

  public initData() {}

  getEditRoute() {
    return [
      this.inspection.isTemplate() ? this.templatesRoute : this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId,
      'plugins',
      this.plugin.id,
      'observationsandrecommandations',
      'edit'
    ];
  }
}

PluginComponent.plugins['observationsandrecommandations'] = ObservationsAndRecommandationsPluginComponent;
PluginComponent.initializers['observationsandrecommandations'] = (plugin: InspectionPlugin) => {
  const point: InspectionPoint = plugin.inspection.pointsById[plugin.pointId];
  let isInActionPlan = false;
  if (plugin.config.ObservationsAndRecommandations && plugin.config.ObservationsAndRecommandations.length > 0) {
    isInActionPlan = plugin.config.ObservationsAndRecommandations.some((o) => o.IsInActionPlan && o.Selected);
  }

  if (isInActionPlan) {
    Icons.initIcon(point, Icons.getIconByName(Icons.observationIconName));
  }
  const notSelectedItems = plugin.config.ObservationsAndRecommandations.filter((o) => !o.Selected);
  if (
    point &&
    point.isDone() &&
    (plugin.config.ObservationsAndRecommandations == null ||
      plugin.config.ObservationsAndRecommandations.length === 0 ||
      plugin.config.ObservationsAndRecommandations.length === notSelectedItems.length)
  ) {
    Icons.initIcon(point, Icons.getIconByName(Icons.pointOkIconName));
  } else {
    Icons.processIcons(false, Icons.getIconByName(Icons.pointOkIconName), plugin.inspection, point);
  }

  if (
    plugin.config.ObservationsAndRecommandations &&
    plugin.config.ObservationsAndRecommandations.some((o) => o.Parts && o.Parts.length)
  ) {
    Icons.initIcon(point, Icons.getIconByName(Icons.hasPartsIconName));
  }
};
